// extracted by mini-css-extract-plugin
export default {"container":"CR-z","title":"DR-z","link":"ER-z"};